import React, { useEffect, useState } from 'react';
import { DS } from '../ds';
import { GradientText, SmileDivider } from '../Visuals';
import { Btn, P } from '../Primitives';
import { AlignerHeroObject } from '../AlignerHeroObject';
export const Hero = ({
  onCTA
}: {
  onCTA: (id: string) => void;
}) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);
  return <section style={{
    minHeight: 'auto',
    paddingTop: '68px',
    paddingBottom: '0px',
    background: `linear-gradient(160deg, #FFFFFF 0%, #F5F5F5 50%, #EAF7F8 100%)`,
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center'
  }} data-id="element-547" data-mp="mrxzs7jp00qf">
      {/* Grid CAD sutil */}
      <div className="anim-grid-drift" style={{
      position: 'absolute',
      inset: 0,
      zIndex: 0,
      pointerEvents: 'none',
      backgroundImage: 'linear-gradient(rgba(26,95,115,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(26,95,115,0.03) 1px, transparent 1px)',
      backgroundSize: '52px 52px',
      opacity: 1
    }} data-id="element-548" data-mp="15lbdz0z6rsjc" />

      {/* Glow teal — esquina superior derecha */}
      <div style={{
      position: 'absolute',
      top: '-15%',
      right: '-8%',
      zIndex: 0,
      width: '55%',
      height: '90%',
      background: 'radial-gradient(ellipse at 70% 30%, rgba(75,199,210,0.10) 0%, transparent 60%)',
      pointerEvents: 'none'
    }} data-id="element-549" data-mp="3rtp746drgwtl" />

      {/* Glow beige — esquina inferior izquierda */}
      <div style={{
      position: 'absolute',
      bottom: '-10%',
      left: '-5%',
      zIndex: 0,
      width: '40%',
      height: '60%',
      background: 'radial-gradient(ellipse at 30% 70%, rgba(181,137,79,0.07) 0%, transparent 60%)',
      pointerEvents: 'none'
    }} data-id="element-550" data-mp="en5l8eb07ihu" />

      {/* Partículas sutiles */}
      {[{
      top: '18%',
      left: '8%',
      size: 3,
      delay: '0s',
      dur: '4s'
    }, {
      top: '65%',
      left: '12%',
      size: 2,
      delay: '1.2s',
      dur: '5s'
    }, {
      top: '30%',
      left: '42%',
      size: 2,
      delay: '0.6s',
      dur: '6s'
    }, {
      top: '75%',
      left: '55%',
      size: 3,
      delay: '2s',
      dur: '4.5s'
    }, {
      top: '12%',
      left: '70%',
      size: 2,
      delay: '0.3s',
      dur: '5.5s'
    }].map((p, i) => <div key={i} style={{
      position: 'absolute',
      top: p.top,
      left: p.left,
      width: `${p.size}px`,
      height: `${p.size}px`,
      borderRadius: '50%',
      background: DS.color.teal,
      opacity: 0.25,
      animation: `particleF ${p.dur} ease-in-out ${p.delay} infinite`,
      zIndex: 0,
      pointerEvents: 'none'
    }} data-id="element-551" data-mp="2hxiq3wnzzf0n" data-mpi={i} />)}

      {/* Contenido */}
      <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '24px 24px 40px',
      width: '100%',
      position: 'relative',
      zIndex: 1
    }} data-id="element-552" data-mp="b2vpcu2aoovu">
        <div className="col-2" style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '60px',
        alignItems: 'center'
      }} data-id="element-553" data-mp="25cts61e3urog">
          {/* Columna izquierda — texto */}
          <div style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'none' : 'translateY(28px)',
          transition: `opacity 0.8s ${DS.ease.out}, transform 0.8s ${DS.ease.out}`
        }} data-id="element-554" data-mp="2ebxerfchdp7p">
            {/* Label superior */}
            <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '6px 16px',
            borderRadius: '100px',
            background: DS.color.mint,
            border: `1px solid ${DS.color.aqua}40`,
            marginBottom: '20px'
          }} data-id="element-555" data-mp="2jdwhcn0eci3l">
              <span style={{
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              background: DS.color.teal,
              display: 'block',
              flexShrink: 0
            }} data-id="element-556" data-mp="vdsnlra178xv" />
              <span style={{
              fontFamily: DS.font.body,
              fontSize: '11px',
              fontWeight: 700,
              color: DS.color.tealDeep,
              letterSpacing: '0.09em',
              textTransform: 'uppercase'
            }} data-id="element-557" data-mp="7qatvq77i0s9">
                Para odontólogos · Ortodoncistas · Clínicas
              </span>
            </div>

            {/* Headline */}
            <h1 style={{
            fontFamily: DS.font.heading,
            fontWeight: 700,
            fontSize: 'clamp(2rem, 4.5vw, 3.2rem)',
            lineHeight: 1.1,
            letterSpacing: '-0.03em',
            color: DS.color.ink,
            marginBottom: '20px',
            marginTop: '4px'
          }} data-id="element-558" data-mp="3q38yiaey1hsr">
              El aliado tecnológico que tu clínica necesita para ofrecer{' '}
              <GradientText data-id="element-559" data-mp="1t83hv6nhamo1">ortodoncia invisible</GradientText>.
            </h1>

            {/* Subtítulo */}
            <P size="lg" maxWidth="460px" data-id="element-560" data-mp="1obd3qov8i159">
              Planeación digital, fabricación precisa y una presentación
              eco-premium que convierte cada caso en una experiencia memorable.
            </P>

            {/* Botones */}
            <div className="hero-btns" style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '14px',
            marginTop: '32px',
            flexWrap: 'wrap'
          }} data-id="element-561" data-mp="1aidlif42hsu0">
              <Btn variant="aqua" size="lg" onClick={() => onCTA('contacto')} data-id="element-562" data-mp="qv0nz7n65yjw">
                Enviar mi primer caso
              </Btn>

              <button type="button" onClick={() => onCTA('proceso')} style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '17px 40px',
              borderRadius: '100px',
              border: `1.5px solid ${DS.color.tealDeep}30`,
              background: DS.color.white,
              color: DS.color.tealDeep,
              fontFamily: DS.font.body,
              fontSize: '16px',
              fontWeight: 600,
              letterSpacing: '0.01em',
              whiteSpace: 'nowrap',
              cursor: 'pointer',
              transition: `all 0.25s ${DS.ease.smooth}`,
              boxShadow: '0 2px 8px rgba(11,31,36,0.06)'
            }} onMouseEnter={e => {
              e.currentTarget.style.background = DS.color.mint;
              e.currentTarget.style.borderColor = `${DS.color.teal}60`;
              e.currentTarget.style.transform = 'translateY(-1px)';
            }} onMouseLeave={e => {
              e.currentTarget.style.background = DS.color.white;
              e.currentTarget.style.borderColor = `${DS.color.tealDeep}30`;
              e.currentTarget.style.transform = 'translateY(0)';
            }} data-id="element-563" data-mp="vt26nrgonvuu">
                Ver proceso
              </button>
            </div>
          </div>

          {/* Columna derecha — objeto 3D */}
          <div style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'none' : 'translateY(32px) scale(0.97)',
          transition: `opacity 1s ${DS.ease.out} 0.2s, transform 1s ${DS.ease.out} 0.2s`
        }} data-id="element-564" data-mp="342iemoq3joiz">
            <div className="anim-aligner" data-id="element-565" data-mp="2cvjmfdrmszwu">
              <AlignerHeroObject data-id="element-566" data-mp="2cwkwbewwvgcz" />
            </div>
          </div>
        </div>
      </div>

      {/* Curva de transición */}
      <div style={{
      position: 'absolute',
      bottom: -2,
      left: 0,
      right: 0
    }} data-id="element-567" data-mp="2hsa23zzixthq">
        <SmileDivider fromColor="#F5F0E800" toColor={DS.color.ivory} data-id="element-568" data-mp="2rko6z1lwfg84" />
      </div>
    </section>;
};